module.exports = __webpack_public_path__ + "img/9788989708810.6e7be6ef.jpg";